import { useQuery } from 'react-query';
import { useCurrentUser, useToastProvider } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import { tagsApi } from '../services/tagsApi';
import { formErrorMessageForToast } from '../utils/backEndErrorMessages';

export const BaseQueryKey = 'tags';

export const useTags = () => {
  const { companyId } = useCurrentUser();
  const { showToast } = useToastProvider();
  const { t } = useTranslation();

  return useQuery([BaseQueryKey, companyId], () => tagsApi.fetchTags(companyId), {
    refetchOnWindowFocus: false,
    onError: (error) => {
      showToast({
        description: formErrorMessageForToast(t('template.hooks.fetchTags.error'), error),
        status: 'error',
        title: t('common.toast.error'),
        'data-cy': 'toast-fetch-tags-error',
      });
    },
  });
};
